<template>
    <CardView title="Stakeholder Groups" ttyId="9" :filterControls="filterControls"></CardView>
</template>

<script>
    import CardView from '@/components/CardView.vue'
    export default {
        name: 'StakeholderGroupCards',
        components: {
            CardView
        },
        data() {
            return {
                filterControls: [{ matId: 876 }, { matId: 877 }]
            }
        },
    }
</script>
<style scoped>
</style>
